import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ThisWeekJobProgressResultFragment = { __typename?: 'ProductionJobProgressResult', productionLotId: string, productionJobId: string, startedAt?: Types.TDateISO | null, startedBy?: string | null, doneAt?: Types.TDateISO | null, doneBy?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null };

export type MarkProductionJobsStartedMutationVariables = Types.Exact<{
  input: Types.MarkProductionJobsStartedInput;
}>;


export type MarkProductionJobsStartedMutation = { __typename?: 'Mutation', markProductionJobsStarted: { __typename?: 'ProductionJobsProgressPayload', results: Array<{ __typename?: 'ProductionJobProgressResult', productionLotId: string, productionJobId: string, startedAt?: Types.TDateISO | null, startedBy?: string | null, doneAt?: Types.TDateISO | null, doneBy?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MarkProductionJobsDoneMutationVariables = Types.Exact<{
  input: Types.MarkProductionJobsDoneInput;
}>;


export type MarkProductionJobsDoneMutation = { __typename?: 'Mutation', markProductionJobsDone: { __typename?: 'ProductionJobsProgressPayload', results: Array<{ __typename?: 'ProductionJobProgressResult', productionLotId: string, productionJobId: string, startedAt?: Types.TDateISO | null, startedBy?: string | null, doneAt?: Types.TDateISO | null, doneBy?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearProductionJobsProgressMutationVariables = Types.Exact<{
  input: Types.ClearProductionJobsProgressInput;
}>;


export type ClearProductionJobsProgressMutation = { __typename?: 'Mutation', clearProductionJobsProgress: { __typename?: 'ProductionJobsProgressPayload', results: Array<{ __typename?: 'ProductionJobProgressResult', productionLotId: string, productionJobId: string, startedAt?: Types.TDateISO | null, startedBy?: string | null, doneAt?: Types.TDateISO | null, doneBy?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionJobNotesMutationVariables = Types.Exact<{
  input: Types.SetProductionJobNotesInput;
}>;


export type SetProductionJobNotesMutation = { __typename?: 'Mutation', setProductionJobNotes: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const ThisWeekJobProgressResultFragmentDoc = new TypedDocumentString(`
    fragment ThisWeekJobProgressResult on ProductionJobProgressResult {
  productionLotId
  productionJobId
  startedAt
  startedBy
  doneAt
  doneBy
  errors {
    code
    message
  }
}
    `, {"fragmentName":"ThisWeekJobProgressResult"});
export const MarkProductionJobsStartedDocument = new TypedDocumentString(`
    mutation MarkProductionJobsStarted($input: MarkProductionJobsStartedInput!) {
  markProductionJobsStarted(input: $input) {
    results {
      ...ThisWeekJobProgressResult
    }
    errors {
      code
      message
    }
  }
}
    fragment ThisWeekJobProgressResult on ProductionJobProgressResult {
  productionLotId
  productionJobId
  startedAt
  startedBy
  doneAt
  doneBy
  errors {
    code
    message
  }
}`);
export const MarkProductionJobsDoneDocument = new TypedDocumentString(`
    mutation MarkProductionJobsDone($input: MarkProductionJobsDoneInput!) {
  markProductionJobsDone(input: $input) {
    results {
      ...ThisWeekJobProgressResult
    }
    errors {
      code
      message
    }
  }
}
    fragment ThisWeekJobProgressResult on ProductionJobProgressResult {
  productionLotId
  productionJobId
  startedAt
  startedBy
  doneAt
  doneBy
  errors {
    code
    message
  }
}`);
export const ClearProductionJobsProgressDocument = new TypedDocumentString(`
    mutation ClearProductionJobsProgress($input: ClearProductionJobsProgressInput!) {
  clearProductionJobsProgress(input: $input) {
    results {
      ...ThisWeekJobProgressResult
    }
    errors {
      code
      message
    }
  }
}
    fragment ThisWeekJobProgressResult on ProductionJobProgressResult {
  productionLotId
  productionJobId
  startedAt
  startedBy
  doneAt
  doneBy
  errors {
    code
    message
  }
}`);
export const SetProductionJobNotesDocument = new TypedDocumentString(`
    mutation SetProductionJobNotes($input: SetProductionJobNotesInput!) {
  setProductionJobNotes(input: $input) {
    productionLot {
      productionLotId
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MarkProductionJobsStarted: build.mutation<MarkProductionJobsStartedMutation, MarkProductionJobsStartedMutationVariables>({
      query: (variables) => ({ document: MarkProductionJobsStartedDocument, variables })
    }),
    MarkProductionJobsDone: build.mutation<MarkProductionJobsDoneMutation, MarkProductionJobsDoneMutationVariables>({
      query: (variables) => ({ document: MarkProductionJobsDoneDocument, variables })
    }),
    ClearProductionJobsProgress: build.mutation<ClearProductionJobsProgressMutation, ClearProductionJobsProgressMutationVariables>({
      query: (variables) => ({ document: ClearProductionJobsProgressDocument, variables })
    }),
    SetProductionJobNotes: build.mutation<SetProductionJobNotesMutation, SetProductionJobNotesMutationVariables>({
      query: (variables) => ({ document: SetProductionJobNotesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMarkProductionJobsStartedMutation, useMarkProductionJobsDoneMutation, useClearProductionJobsProgressMutation, useSetProductionJobNotesMutation } = injectedRtkApi;
